
import { Component, Vue, Prop } from 'vue-property-decorator';
import { TextBoxEnum } from '@/models/textBoxEnum';

export interface TextBoxData {
  title: TextBoxEnum;
  content: string;
}

@Component({
  components: {}
})
export default class TextBoxCard extends Vue {
  @Prop({ required: true })
  protected data?: TextBoxData;

  protected getColorByTitle(): string {
    switch (this.data?.title) {
      case TextBoxEnum.INFO:
        return 'info';
      case TextBoxEnum.SUCCESS:
        return 'primary';
      case TextBoxEnum.WARNING:
        return 'warning';
      case TextBoxEnum.ERROR:
        return 'error';
      default:
        return 'error';
    }
  }
}
